/** Provides `t` and the locale to the presentational components (D-055: no business strings in code). */
import { createContext, useContext, type ReactNode } from "react";
import { createT, type Locale, type Translate } from "@faylasuf/i18n";

export interface I18nContextValue {
  readonly locale: Locale;
  readonly t: Translate;
}

const I18nContext = createContext<I18nContextValue>({ locale: "ar", t: createT("ar") });

export function I18nProvider({ locale, t, children }: { locale: Locale; t: Translate; children: ReactNode }) {
  return <I18nContext.Provider value={{ locale, t }}>{children}</I18nContext.Provider>;
}

export function useI18n(): I18nContextValue {
  return useContext(I18nContext);
}

export function useT(): Translate {
  return useContext(I18nContext).t;
}
